<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="系统设置"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-cell-group class="martop0">
      <!-- <van-cell center title="音效">
        <template #right-icon>
          <van-switch v-model="musicChecked" size="24" active-color="#24a378" />
        </template>
      </van-cell>
      <van-cell center title="信息提醒">
        <template #right-icon>
          <van-switch v-model="msgtipsChecked" size="24" active-color="#24a378" />
        </template>
      </van-cell> -->
      <van-cell center title="修改密码" is-link to="/AccountPwd" />
      <!-- <van-cell center title="清除缓存" value="10M" value-class="t12" is-link /> -->
    </van-cell-group>

    <van-cell-group>
      <div @click="logout" class="van-cell van-cell--center van-cell--clickable">
        <p class="flexmid text-center">退出登录</p>
      </div>
    </van-cell-group>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      musicChecked: false,
      msgtipsChecked: false
    };
  },
  components: {
    ...mapGetters(["currentToken"])
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    logout() {
      var that = this;

      Dialog.confirm({
        // title: "提示",
        message: "确定退出吗？"
      })
        .then(() => {
          this.$store.dispatch({ type: "Logout" }).then(() => {
              that.$router.go(-1);
            //that.$router.replace("/Guide");
          });
        })
        .catch(() => {});

    }
  }
};
</script>

<style scoped>
</style>
